import React, { useState } from 'react';
import { ListItemIcon } from '@mui/material';
import { StyledMenu, StyledMenuItem } from './styled';

const SubMenu = ({ title, icon, options, onClose }) => {
    const [anchorEl, setAnchorEl] = useState();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
        setAnchorEl(null);
    };

    return (
        <StyledMenuItem onClick={handleClick}>
            <ListItemIcon>{icon}</ListItemIcon>
            {title}
            <StyledMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {options.map((o, idx) => (
                    <StyledMenuItem
                        disabled={o.disabled}
                        className={`menuItem${o.name}`}
                        key={idx}
                        onClick={() => {
                            handleClose();
                            o.onClick();
                        }}
                        divider={o.divider}
                    >
                        <ListItemIcon>{o.icon}</ListItemIcon>
                        {o.text}
                    </StyledMenuItem>
                ))}
            </StyledMenu>
        </StyledMenuItem>
    );
};

export default SubMenu;
